import PropTypes from 'prop-types'

const InfoCard = ({
  title,
  children,
  icon: Icon,
  iconBgColor = 'bg-primary-100 dark:bg-primary-900',
  iconColor = 'text-primary-600 dark:text-primary-400',
  className = '',
  headerClassName = '',
  bodyClassName = '',
}) => {
  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md ${className}`}
    >
      {title && (
        <div
          className={`px-6 py-4 border-b border-neutral-200 dark:border-neutral-700 ${headerClassName}`}
        >
          <div className="flex items-center space-x-3">
            {Icon && (
              <div className={`w-8 h-8 ${iconBgColor} rounded-lg flex items-center justify-center`}>
                <Icon className={`${iconColor} text-lg`} />
              </div>
            )}
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">{title}</h3>
          </div>
        </div>
      )}

      <div className={`px-6 py-4 ${bodyClassName}`}>{children}</div>
    </div>
  )
}

InfoCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  iconBgColor: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
}

export default InfoCard
